import { render, staticRenderFns } from "./Licitaciones.vue?vue&type=template&id=b2141072&scoped=true"
import script from "./Licitaciones.vue?vue&type=script&lang=ts"
export * from "./Licitaciones.vue?vue&type=script&lang=ts"
import style0 from "./Licitaciones.vue?vue&type=style&index=0&id=b2141072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2141072",
  null
  
)

export default component.exports